/**
 * CSS infinite marquees can stick after tab sleep, bfcache restore, or visibility toggles.
 * Clearing inline animation forces the browser to re-apply Tailwind's animation classes.
 */
export function restartMarqueeAnimations(): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.querySelectorAll<HTMLElement>('.marquee-track').forEach((el) => {
        el.style.animation = 'none';
        el.style.webkitAnimation = 'none';
        void el.offsetHeight;
        el.style.animation = '';
        el.style.webkitAnimation = '';
      });
    });
  });
}
